/**
 * @generated SignedSource<<90d6aae7ba59944fc13a2c78b301a06f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductSkuPaymentData_Product$data = {
  readonly skus: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly paymentOptions: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly __typename: string;
            };
          }>;
          readonly " $fragmentSpreads": FragmentRefs<"BestPaymentMethod_PaymentOptionConnection" | "PaymentsMethodsListDrawer_PaymentOptionConnection">;
        } | null;
      };
    }>;
  };
  readonly " $fragmentType": "ProductSkuPaymentData_Product";
};
export type ProductSkuPaymentData_Product$key = {
  readonly " $data"?: ProductSkuPaymentData_Product$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductSkuPaymentData_Product">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "addresses"
    },
    {
      "kind": "RootArgument",
      "name": "paymentMethod"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductSkuPaymentData_Product",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductSkuConnection",
      "kind": "LinkedField",
      "name": "skus",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProductSkuEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProductSku",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "addresses",
                      "variableName": "addresses"
                    },
                    {
                      "kind": "Variable",
                      "name": "paymentMethod",
                      "variableName": "paymentMethod"
                    }
                  ],
                  "concreteType": "PaymentOptionConnection",
                  "kind": "LinkedField",
                  "name": "paymentOptions",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "PaymentOptionEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "PaymentOption",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "__typename",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "BestPaymentMethod_PaymentOptionConnection"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "PaymentsMethodsListDrawer_PaymentOptionConnection"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Product",
  "abstractKey": null
};

(node as any).hash = "00fb8130e7664852c1347be2a7a5320a";

export default node;
